var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 50,
    viewBox: "0 0 798.000000 302.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,302.000000) scale(0.100000,-0.100000)",
    fill: "#023E8ACC",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795 3005 c-395 -73 -699 -386 -770 -794 -15 -86 -20 -235 -9 -289 l6 -31 712 -4 c697 -3 713 -3 795 -25 360 -96 627 -373 706 -733 12 -56 14 55 14 914 l1 977 -692 -1 c-521 -1 -710 -4 -763 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370 1505 l0 -1495 910 0 910 0 2 624 3 624 465 -445 c256 -245 549 -526 653 -625 l187 -180 0 1496 0 1496 -655 0 -655 0 -2 -866 -3 -865 -903 865 c-497 476 -906 866 -908 866 -2 0 -4 -673 -4 -1495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5600 1500 l0 -1501 548 4 c517 3 552 5 644 25 288 65 533 199 737 403 215 214 361 492 417 794 14 73 19 146 19 275 0 270 -45 465 -160 690 -207 404 -567 681 -1013 782 -92 20 -127 22 -644 25 l-548 4 0 -1501z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 937 l-1 -928 713 4 c700 3 713 3 797 25 271 72 500 254 621 493 65 131 91 233 96 391 l6 137 -724 3 c-720 4 -724 4 -804 27 -169 48 -302 127 -426 250 -137 137 -224 296 -268 486 -6 25 -9 -299 -10 -888z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanad);
export default __webpack_public_path__ + "static/media/sanad.973577344d3d2ce452e70eb0941222d0.svg";
export { ForwardRef as ReactComponent };